import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MailIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqGroups } from '../data/faq';
export function Faq() {
  const [open, setOpen] = useState<string | null>(null);
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-66" data-mp="1gcxsoqzdze2y">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-67" data-mp="2e0fxxrtu9y27">
        <Reveal data-id="element-68" data-mp="2dz4slnkqwi8z">
          <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-69" data-mp="2dzobb6i7zao2">
            Preguntas frecuentes
          </p>
          <h2 id="faq-title" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-[2.6rem]" data-id="element-70" data-mp="24206fnqwgms6">
            Todo lo que necesitas saber antes de empezar
          </h2>
        </Reveal>

        <div className="mt-12 space-y-12" data-id="element-71" data-mp="snd4ntodlqmt">
          {faqGroups.map(group => <div key={group.id} data-id="element-72" data-mp="no0ccteqjrcu">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-ink/60" data-id="element-73" data-mp="nmyx0cqosipb">
                {group.title}
              </h3>
              <ul className="mt-4 divide-y divide-bark/10 border-y border-bark/10" data-id="element-74" data-mp="pfv0e4xzeoae">
                {group.items.map(item => {
              const id = `${group.id}-${item.q}`;
              const isOpen = open === id;
              return <li key={id} data-id="element-75" data-mp="kil3y5c6dcd2">
                      <h4 data-id="element-76" data-mp="khtlzxbi3d59">
                        <button type="button" onClick={() => setOpen(isOpen ? null : id)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-4 text-left transition-colors duration-150 ease-out hover:text-clay focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-77" data-mp="kh0ayk5ie1hb">
                          <span className="font-medium leading-snug text-bark" data-id="element-78" data-mp="3swjzx6z5cxqk">{item.q}</span>
                          <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-ink/50 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-79" data-mp="1sn0k2jbo7fr" />
                        </button>
                      </h4>

                      <AnimatePresence initial={false} data-id="element-80" data-mp="1ugkxuc35aamg">
                        {isOpen && <motion.div key="content" initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.22,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-81" data-mp="1uixmt97bll90">
                            <div className="space-y-3 pb-6 pr-8 text-sm leading-relaxed text-ink/80" data-id="element-82" data-mp="28hf5utma69kl">
                              {item.paragraphs.map((p, i) => <p key={i} data-id="element-83" data-mp="1zfxrpgsfohyj" data-mpi={i}>{p}</p>)}
                              {item.bullets && <ul className="space-y-2 pl-1" data-id="element-84" data-mp="1zfo1pt7e2asu">
                                  {item.bullets.map(b => <li key={b} className="flex gap-2.5" data-id="element-85" data-mp="s3xeneraaqm5">
                                      <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-clay" aria-hidden="true" data-id="element-86" data-mp="o0ityasehm2d" />
                                      <span data-id="element-87" data-mp="2zpp4kc5ksk1j">{b}</span>
                                    </li>)}
                                </ul>}
                              {item.after && <p data-id="element-88" data-mp="38p2fl99clgod">{item.after}</p>}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </li>;
            })}
              </ul>
            </div>)}
        </div>

        <Reveal data-id="element-89" data-mp="3idu4t9n0xmvl">
          
        </Reveal>
      </div>
    </section>;
}